/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LearningCompetenceSimpleTypeEnum {
    Competence = 'Competence',
    Learning = 'Learning',
    All = 'All'
}

export function LearningCompetenceSimpleTypeEnumFromJSON(json: any): LearningCompetenceSimpleTypeEnum {
    return LearningCompetenceSimpleTypeEnumFromJSONTyped(json, false);
}

export function LearningCompetenceSimpleTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningCompetenceSimpleTypeEnum {
    return json as LearningCompetenceSimpleTypeEnum;
}

export function LearningCompetenceSimpleTypeEnumToJSON(value?: LearningCompetenceSimpleTypeEnum | null): any {
    return value as any;
}

